import { GlobeAltIcon } from '@heroicons/react/24/outline';
import React from 'react';

/**
 * UK-only for MVP: Static display of United Kingdom and GBP.
 * Country/currency selection disabled - international orders not yet supported.
 */
const LocaleSelector: React.FC = () => {
  return (
    <div
      className='flex items-center gap-2 px-2 py-1 rounded-md text-default-600'
      title='United Kingdom only - international shipping coming soon'
    >
      <GlobeAltIcon className='h-4 w-4' />
      <span className='hidden sm:inline' aria-hidden='true'>
        🇬🇧
      </span>
      <span className='hidden md:inline text-sm font-medium'>
        United Kingdom | £
      </span>
    </div>
  );
};

export default LocaleSelector;
